/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Number/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Number({
  children,
  viewPath = "/DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone/Phones/Content/Phone/Edit/Content/Fields/Number",
  isInvalid,
  onChange
  
}) {
let editPhonePhoneNumberValueData = fromData.useDataFormat({ viewPath,
context: 'edit_phone',
path: 'phone.number',
format: fromFormat.phoneNumberUS,
})
let editPhonePhoneNumberIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_phone',
path: 'phone.number',
validate: fromValidate.phoneNumber,
required: true,
})
let editPhonePhoneNumberChangeData = fromData.useDataChange({ viewPath,
context: 'edit_phone',
path: 'phone.number',
formatOut: fromFormat.addPrefixIfMissing,
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_phone.phone.number"
 validate="/Data/validate.js phoneNumber"
 invalid={!editPhonePhoneNumberIsValidData}
 format="/Data/format.js phoneNumberUS"
 formatOut="/Data/format.js addPrefixIfMissing"
 required={true}
 value={editPhonePhoneNumberValueData}
 onChange={editPhonePhoneNumberChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Number"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 mask="phone"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}